<template>
	<div class="s-gray-bg" style="min-height:100vh;padding-top: 1rem;">

		<div v-if="!isLoading" class="p-margin20  p-white-bg p-radius20 p-black" style="width: auto;padding:5rem 1rem;">

			
			<div style="width: 100%;text-align: center;">
				<img src="../assets/img/loading.gif" />
			</div>
			<div class="p-color6-border p-color3 p-font0-8 p-padding-bottom20"
				style="width: 100%;text-align: center;padding-top: 0.5rem;">
				{{isAppling?'您的报告还在分析中,':''}}解析报告需要1-2个小时
			</div>
		</div>

	<loading v-if="isLoading"></loading>

	</div>


</template>

<script>
	import loading from "../components/loading/loading";
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	import {
		getNibpReportHistoryListData,
		applyNibpReportData
	} from '@/api/api.js';
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loading,
		},
		data() {
			return {
				title: '',
				isLoading:true,
				isAppling: false,
			}
		},
		methods: {
			// 获取不同类型数据
			getData() {
				getNibpReportHistoryListData({
					pid: this.$route.query.pid, // 网址传参--------------------------
				}).then(res => {
					console.log("getNibpReportHistoryList-res nibpReportListJson:------- ", res);
		
					var nibpReportListJson = res.data.data;
					this.isLoading=false;
					if(nibpReportListJson){//获取列表中是否有未完成的
						console.log("getNibpReportHistoryList-res nibpReportListJson1:------- ", nibpReportListJson[0]);
						if(nibpReportListJson.length>0&&nibpReportListJson[0].status==1){
							this.isAppling=true;
						}else{
							this.isAppling=false;
							this.applyNibpReprot();
						}
					}
				});
			},
			goToDetailFunction(tmpDays){
				console.log("goToDetailFunction:------- ", tmpDays);
				this.isAppling=false;
				this.$router.push({
					path: '/bloodPressureReportApplyFail',
					query: {
						pid: this.$route.query.pid,
						days:tmpDays,
					}
				})
			},
			applyNibpReprot(){
				var ets=new Date().getTime()
				var sts=new Date(new Date(new Date().toLocaleDateString()).getTime()-6*24*60*60*1000).getTime()
				console.log("applyNibpReprot ets sts:------- ", ets,sts);
				applyNibpReportData({
					pid: this.$route.query.pid, // 网址传参--------------------------
					sts: sts, // 网址传参--------------------------
					ets: ets, // 网址传参--------------------------
				}).then(res => {
					console.log("applyNibpReprot:------- ", res);
					// this.visibleReportDays=res.data.data.statusList;
					// console.log("applyNibpReprot:1------- ", this.visibleReportDays);
					if(res.data.data.count>=3){
						this.isAppling=true;
					}else{
						// this.updateNibpReportApplyFailData(this.visibleReportDays);
						console.log("goToDetailFunction:------- ", res.data.data);
						this.isAppling=false;
						this.$router.replace({
							path: '/bloodPressureReportApplyFailLiandai',
							query: {
								pid: this.$route.query.pid,
								days:res.data.data,
							}
						})
								//确认弹窗
						// let options={
						// 	title:"数据不足",
						// 	message:"您上周测量次数未达标，数据无法生成准确诊断",
						// 	options:{
						// 			yesCallbackFunction:this.goToDetailFunction,
						// 			rightColor:this.colorArr[4],
						// 		//  noCallbackFunction:this.noCallbackFunction,
						// 			yesText:'前往查看',
						// 		  	noText:'取消',
						// 				data:res.data.data
						// 		}
						// }
						// this.$installdialog.confirm(options);
						
					}
				
				});
				
			}

		},
		created() {
			document.title = this.$t('measure.bloodPressureReportExplain')
			this.getData();

		},
	}
</script>

<style scoped>

</style>
